import request from './request'

// 获取分组列表
export function tempgroupGetList(params) {
  return request({
    url: '/product-template-group/list',
    method: 'get',
    params
  })
}

// 分组创建
export function tempgroupCreate(data) {
  return request({
    url: '/product-template-group/create',
    method: 'post',
    data
  })
}

// 获取模板列表
export function tempexportGetList(params) {
  return request({
    url: '/product-template/list',
    method: 'get',
    params
  })
}

// 模板创建
export function tempexportCreate(data) {
  return request({
    url: '/product-template/create',
    method: 'post',
    data
  })
}

// 获取模板详情
export function tempexportDetail(id) {
  return request({
    url: '/product-template/detail/' + id,
    method: 'get'
  })
}

// 更新模板
export function tempexportUpdate(id, data) {
  return request({
    url: '/product-template/update/' + id,
    method: 'put',
    data
  })
}

// 删除模板
export function tempexportDelete(id) {
  return request({
    url: '/product-template/delete/' + id,
    method: 'delete'
  })
}

// 复制模板任务
export function tempexportCopy(id) {
  return request({
    url: '/product-template/copy/' + id,
    method: 'get'
  })
}

// 移动模板
export function tempexportRemove(data) {
  return request({
    url: '/product-template/batch-update-group',
    method: 'post',
    data
  })
}

// 移动模板
export function tempexportShare(data) {
  return request({
    url: '/product-template/shareToSubAccounts',
    method: 'post',
    data
  })
}

// 设置模板公开
export function tempexportUpdatePublic(data) {
  return request({
    url: '/product-template/update-public-status',
    method: 'post',
    data
  })
}


// 上传excel
export function tempexportUpload(data) {
  return request({
    url: '/product-template/upload-excel',
    method: 'post',
    data
  })
}

// 解析excel
export function tempexportParse(data) {
  return request({
    url: '/product-template/parse-excel',
    method: 'post',
    data
  })
}
